import CryptoJS from 'crypto-js';
const secretKey = 'DIJs0Nj1NYXD6dcAGb2oPTYA42w6qnjVa1MFxfxWHe69fVwjlBg2VTWdX'; // 
export const encryptToken = (token) => {
    const encrypted = CryptoJS.AES.encrypt(token, secretKey).toString(); // تحويل التشفير إلى نص
    return encrypted
        .replace(/\+/g, '-') // استبدال "+" بـ "-"
        .replace(/\//g, '_') // استبدال "/" بـ "_"
        .replace(/=+$/, ''); // إزالة "=" في النهاية
};

export const decryptToken = (encryptedToken) => {
    console.log(encryptedToken,"skdlsdlklskds");
    
    const base64Regex = /^[A-Za-z0-9+/=_-]+$/;

    try {
        // التحقق من التنسيق
        if (!base64Regex.test(encryptedToken)) {
            throw new Error("Invalid token format");
        }

        // إعادة الأحرف المشفرة إلى الشكل الأصلي
        const normalizedToken = encryptedToken
            .replace(/-/g, '+') 
            .replace(/_/g, '/')
            .padEnd(encryptedToken.length + (4 - (encryptedToken.length % 4)) % 4, '=');

        // فك التشفير
        const bytes = CryptoJS.AES.decrypt(normalizedToken, secretKey);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        if (!decrypted) throw new Error("Decryption failed");

        return decrypted; // إعادة النص العادي
    } catch (error) {
        console.error("Decryption Error:", error.message);
        return null; // إرجاع null في حالة الخطأ
    }
};
